/*-------------------------------------------------------------------------------------------
Program     :  ParticipantsDialog.js
Description :  Main program for Map and track Participant view 
Date        :  25/05/2025 
Created By  :  Jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
25052025        - Jelbin     - 25/05/2025         Created
---------------------------------------------------------------------------------------------*/
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from '@mui/material/CircularProgress';
import Alert from "@mui/material/Alert";
import { Stack, Tooltip, Box } from '@mui/material';
import TimeCalculationService from '../service/TimeCalculationService';
import Avatar from '@mui/material/Avatar';
import { useMapTrackInfo } from "../context/Maptrackcontext";
import HolidayDialog from "./HolidayDialog";
import ReportIcon from '@mui/icons-material/Report';

const ParticipantsDialog = ({
  selectedtask,
  selectedagentindexval,
  participantsData,
  tableUniqueName,
  tskTravelTimeField,
  selectedtraveler,
  mapVisibilityDate,
  ZDATERANGE,
  durationFieldsY,
  fielduserstartTime,
  startTimeField,
  endTimeField,
  fixschedulefield,
  handleDataReassign,
  selectedSourceMapname
}) => {
  const { combinedData, setCombinedData, setDataModified, participantsFields, 
  mergeparticipantFields,setdlgOpen,setselectedTaskVal,setselectedCalenderTaskVal, 
  settaskClicked,participantTaskTime,setParticipantTaskTime,holidayPayload,
  onlyuserChange,setTravelbuttonEnable,setSavebuttonEnable,agentColor,setagentColor} = useMapTrackInfo();


  const [dlgParticipants, setdlgParticipants] = useState(false);
  const [participantSelected, setparticipantSelected] = useState("");
  const [participantConfirm, setParticipantConfirm] = useState(false);
  const [selectedUniquetask, setSelectedUniquetask] = useState(0);
  const [selectedAgentIndex, setSelectedAgentIndex] = useState(0);
  const [newParticipant, setnewParticipant] = useState("");
  const [participantIndex, setnewParticipantIndex] = useState(0);
  const [isparticipantExist, setisparticipantExist] = useState(false);
  const [participantProcess, setParticipantProcess] = useState(false);
  const [showHolidayDialog, setShowHolidayDialog] = useState(false);

  const handleSelectParticipants = (participant, partIndex, uniquevalue, agentindex,partiColor) => {
    setdlgParticipants(true);
    setparticipantSelected(participant);
    setnewParticipant(participant);
    setSelectedUniquetask(uniquevalue);
    setSelectedAgentIndex(agentindex);
    setagentColor(partiColor);
  }

  const handleDlgParticipantsClose = () => {
    setdlgParticipants(false);
    setisparticipantExist(false);
  }

  const handleParticipantsChange = (newParticipantvalue, newpartindex) => {
    const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(holidayPayload, selectedtraveler, newParticipantvalue, mapVisibilityDate);
    if (isUserHoliday) {
      setShowHolidayDialog(true);
    }
    //else {
    setnewParticipant(newParticipantvalue);
    setnewParticipantIndex(newpartindex);
    setParticipantConfirm(true)
    //}
  };

  const handleHolidayYes = () => {
    setShowHolidayDialog(false);
   // setdlgParticipants(false);
   // setParticipantConfirm(false);
   // setdlgOpen(false);
  }

  const handleParticipantsConfirm = async () => {
    setTravelbuttonEnable(true);
    setSavebuttonEnable(false);
    //  Deep copy the entire structure
    let updatedData ;
    if (onlyuserChange === true) // If any user & Participant change together
    {
      updatedData = await handleDataReassign(); 
    }
    else{
      updatedData = structuredClone(combinedData);
    }
    const selectedAgent = updatedData[selectedAgentIndex];

    // Check the main user is on Holiday or not
    const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(holidayPayload, selectedtraveler, selectedAgent[selectedtraveler], mapVisibilityDate);
    if (isUserHoliday && newParticipant !== "") {
      setShowHolidayDialog(true);
    }
    else {
      setisparticipantExist(false);
      setParticipantProcess(true);
      let detailsBlock = selectedAgent.details.find(
        (detail) => detail[tableUniqueName] === selectedUniquetask
      );
      if (detailsBlock) {
        //  Check if newParticipant is already assigned
        const alreadyAssigned = participantsFields.some(
          (field) => detailsBlock[field] === newParticipant && newParticipant !== ""
        );

        if (alreadyAssigned) {
          console.log(`Participant ${newParticipant} is already assigned in this task.`);
          setisparticipantExist(true);
          setParticipantProcess(false);
        } else {
          // Update participant fields
          for (let userIndex = 0; userIndex < mergeparticipantFields.length; userIndex++) {
            const { ZPARTCIPANTFILED, ZPARTTRVLTIMEFILED } = mergeparticipantFields[userIndex];

            if (participantSelected !== null && onlyuserChange === false) {
              if (detailsBlock[ZPARTCIPANTFILED] === participantSelected) {
                detailsBlock[ZPARTCIPANTFILED] = newParticipant === "" ? null : newParticipant;
                detailsBlock[ZPARTTRVLTIMEFILED] = "00:00";
                detailsBlock.recordchange = true;
              }
            } else {
              if (detailsBlock[ZPARTCIPANTFILED] === null) {
                detailsBlock[ZPARTCIPANTFILED] = newParticipant === "" ? null : newParticipant;
                detailsBlock[ZPARTTRVLTIMEFILED] = "00:00";
                detailsBlock.recordchange = true;
                break; // break after the first null field gets update.
              }
            }
          }
          // Recalculate travel time for updated agent
          // const finalDatawithPartTravelTime = await TimeCalculationService.calculateParticipantSchedule(
          //   selectedAgent,
          //   tskTravelTimeField,
          //   selectedtraveler,
          //   mapVisibilityDate,
          //   ZDATERANGE,
          //   participantsData,
          //   mergeparticipantFields,
          //   false,
          //   true,
          //   selectedSourceMapname
          // ); JKB

          // Recalculate task duration
          // await TimeCalculationService.calculatetaskdurationwithparticipants(
          //   selectedAgent,
          //   durationFieldsY,
          //   participantsData,
          //   selectedtraveler,
          //   mapVisibilityDate,
          //   ZDATERANGE,
          //   mergeparticipantFields,
          //   true
          // ); JKB

          // Recalculate task times
          // const dayStartTime = selectedAgent[fielduserstartTime];
          // const detailsWithNewTimes = TimeCalculationService.recalculateTaskTimes(
          //   selectedAgent.details,
          //   startTimeField,
          //   endTimeField,
          //   durationFieldsY,
          //   dayStartTime,
          //   tskTravelTimeField,
          //   fixschedulefield,
          //   mapVisibilityDate,
          //   ZDATERANGE,
          // ); JKB

          // selectedAgent.details = detailsWithNewTimes; JKB

          // Update the updatedData with Main CombinedData payload
          setCombinedData(updatedData);

          //Call the function participantTotalTaskTime and it will create new payload 
          //with each partcipant Total Task time. 
          // const FinalPartiTaskTime = await TimeCalculationService.participantTotalTaskTime(selectedtraveler,
          //   ZDATERANGE, participantsData, mergeparticipantFields, updatedData,durationFieldsY);
          // setParticipantTaskTime(FinalPartiTaskTime); JKB
          // Set updated data and clean up
          setDataModified(true);
          setdlgParticipants(false);
          setparticipantSelected("");
          setSelectedUniquetask(0);
          setSelectedAgentIndex(0);
          setnewParticipantIndex();
          setisparticipantExist(false);
          setParticipantProcess(false);
          setdlgOpen(false);
          setselectedTaskVal({});
          setselectedCalenderTaskVal({});
          settaskClicked(false);
          setParticipantConfirm(false);
        }
      }
    }
  };


  return (
    <>
      <Stack direction="row" spacing={1}>
        {/*Display the task participants name*/}
        {participantsFields.map((field, partindex) => {
          let participant = null;
          if (selectedtask.hasOwnProperty(field)) {
            participant = selectedtask[field];
          } else {
            participant = "+";
          }
          const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(
            holidayPayload,
            selectedtraveler,
            participant,
            mapVisibilityDate
          );
          return (
            <Tooltip title={participant} arrow>
              <Box position="relative" width={24} height={24} onClick={() =>
                handleSelectParticipants(
                  participant,
                  partindex,
                  selectedtask[tableUniqueName],
                  selectedagentindexval,
                  selectedtask.color
                )
              }>
                <Avatar
                  key={field}
                  sx={{
                    width: 24,
                    height: 24,
                    fontSize: 10,
                    bgcolor: selectedtask.color
                  }}
                >
                  {participant !== "+" ? TimeCalculationService.formatUsername(participant) : "+"}
                </Avatar>
                {/* Show ReportIcon if partcipant is on holiday*/}
                {isUserHoliday && (
                  <Tooltip title="Absent" arrow>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -6,
                        right: -6
                      }}
                    >
                      <ReportIcon
                        fontSize="small"
                        sx={{
                          color: 'red',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          padding: '1px'
                        }}
                      />
                    </Box>
                  </Tooltip>
                )}
              </Box>
            </Tooltip>
          );
        })}
      </Stack>
      <Dialog open={dlgParticipants} PaperProps={{
      sx: {
        border: `2px solid ${agentColor}`,
        borderRadius: 5,
      },
    }}>
        <DialogTitle>Change Participants</DialogTitle>
        <DialogContent>
          <div>
            <strong style={{ fontSize: '0.9em' }}>Participant: </strong> {participantSelected}
          </div>

          {/* User Selection Dropdown  */}
          <FormControl fullWidth style={{ marginTop: '16px' }}>
            <InputLabel id="user-select-label">Select Participants</InputLabel>
            <Select
              labelId="user-select-label"
              id="user-select"
              value={newParticipant}
              label="Select Participants"
            >
              <MenuItem key="default" value="" onClick={() => handleParticipantsChange("", 0)}>
                No participant
              </MenuItem>
              {participantsData.map((agent, index) => (
                <MenuItem
                  key={index}
                  value={agent[selectedtraveler]}
                  data-index={index}
                  onClick={() => handleParticipantsChange(agent[selectedtraveler], index)}
                >
                  {agent[selectedtraveler]}
                </MenuItem>
              ))}
            </Select>
            {isparticipantExist ?
              <Alert severity="error"> Participant already assigned <br /> in this task</Alert>
              : <></>}
          </FormControl>
        </DialogContent>

        <DialogActions>
          {!participantProcess ? (
            <>
              <Button disabled={!participantConfirm} onClick={handleParticipantsConfirm}>
                Confirm
              </Button>
              <Button onClick={handleDlgParticipantsClose}>
                Cancel
              </Button>
            </>
          ) : (
            <div>
              <CircularProgress size={25} />&nbsp;Processing data reassignment...
            </div>
          )}
        </DialogActions>
      </Dialog>
      {showHolidayDialog && <HolidayDialog
        dlgHoliday={showHolidayDialog}
        handleHolidayYes={handleHolidayYes} />}
    </>
  );
};

export default ParticipantsDialog;